import { createV3Queries } from "@query/utils/createV3Queries";
import { accountingReferenceDataApi } from "@api";

/**
 * The connected accounting partner's reference data — the QuickBooks customers,
 * items, vendors, classes and ledger accounts a mapping can point at
 * (`/v3/platform/accounting-connections/:connectionId/*`).
 *
 * Every read is scoped to ONE connection, so resolve the connection first (see
 * [[selectorQuickbooksConnection]] over
 * `queriesAccountingConnections.listAccountingConnections`) and gate these on
 * its id.
 */
export const queriesAccountingReferenceData = createV3Queries(
  "accountingReferenceDataApi",
  accountingReferenceDataApi
);
